// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileZipOutlinedSvg from "@fishx/icons-svg/es/asn/PFileZipOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileZipOutlined = function PFileZipOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileZipOutlinedSvg
  }));
};

PFileZipOutlined.displayName = 'PFileZipOutlined';
export default React.forwardRef(PFileZipOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileZipOutlined.js
// module id = 3414
// module chunks = 0